export const isElementWithinInertText = (element: HTMLElement) => {
  if (element) {
    const parentEl = element?.closest('[inert="true"]');
    if (parentEl) {
      const isElementBlurred = parentEl?.contains(element);
      return isElementBlurred;
    }
  }
  return false;
};

export default isElementWithinInertText;
